export default "__VITE_ASSET__DEAI0ys9__";